import React, {useEffect, useState} from 'react';
import {Button, Form, Upload} from 'antd';
import TextArea from 'antd/es/input/TextArea';
import {UploadOutlined} from '@ant-design/icons';
import './PbssInternationalAdmin.css';
import {
  UploadFileMaxSizeForImage,
  UploadFileMaxSizeForImages,
  UploadFileMaxSize,
  displayFileName,
} from '../../../Util/commonUtility';
import {applicationConfig} from '../../../Util/config';
import {useDispatch} from 'react-redux';
import {FETCH_ERROR} from '../../../Constant/ActionTypes';
import useLocalization from '../../../Localization';
import CommonEditor from '../../CommonComponents/TextEditor';

const PbssInternationalComponent = (props) => {
  const [form] = Form.useForm();
  const {ApplicationString} = useLocalization();
  const {EditData, updatePbssInternational} = props;
  const [validImageFileList, setValidImageFileList] = useState([]);
  const [validPbssSponsorFileList, setValidPbssSponsorFileList] = useState([]);
  const [validAboutUsImageFileList, setValidAboutUsImageFileList] = useState(
    [],
  );
  const [validFileList, setValidFileList] = useState([]);
  const [pbssIntroState, setPbssIntroState] = useState('<p></p>');
  const [ourMissionState, setOurMissionState] = useState('<p></p>');
  const dispatch = useDispatch();
  const filesImageFormats = ['image/jpeg', 'image/png', 'image/jpg'];
  const filesFormats = ['application/pdf'];

  const uploadPropsPbssSponsors = {
    name: 'file',
    multiple: true,
    maxCount: 20,
    beforeUpload: (file) => {
      const isRightFormat = filesImageFormats.includes(file.type);

      if (!isRightFormat) {
        dispatch({
          type: FETCH_ERROR,
          payload: 'Accepted file formats: JPG and PNG only',
        });
        return;
      }
      const isLt2M = file.size / 1024 / 1024 < UploadFileMaxSizeForImage;
      if (!isLt2M) {
        dispatch({
          type: FETCH_ERROR,
          payload: `File must smaller than ${UploadFileMaxSizeForImage}MB!`,
        });
        return false;
      }
      setValidPbssSponsorFileList((prev) => {
        if (prev.length >= 20) {
          dispatch({
            type: FETCH_ERROR,
            payload: 'Maximum 20 files can be uploaded',
          });
          return prev;
        }
        return [...prev, file];
      });

      return isRightFormat && isLt2M;
    },
  };

  const uploadPropsImage = {
    name: 'file',
    multiple: true,
    maxCount: 20,
    beforeUpload: (file) => {
      const isRightFormat = filesImageFormats.includes(file.type);

      if (!isRightFormat) {
        dispatch({
          type: FETCH_ERROR,
          payload: 'Accepted file formats: JPG and PNG only',
        });
        return;
      }
      const isLt2M = file.size / 1024 / 1024 < UploadFileMaxSizeForImage;
      if (!isLt2M) {
        dispatch({
          type: FETCH_ERROR,
          payload: `File must smaller than ${UploadFileMaxSizeForImage}MB!`,
        });
        return false;
      }
      setValidImageFileList((prev) => {
        if (prev.length >= 20) {
          dispatch({
            type: FETCH_ERROR,
            payload: 'Maximum 20 files can be uploaded',
          });
          return prev;
        }
        return [...prev, file];
      });

      return isRightFormat && isLt2M;
    },
  };

  const fileUploadProps = {
    name: 'file',
    multiple: false,
    maxCount: 1,
    beforeUpload: (file) => {
      const isRightFormat = filesFormats.includes(file.type);

      if (!isRightFormat) {
        dispatch({
          type: FETCH_ERROR,
          payload: 'Accepted file formats: PDF only',
        });
        return;
      }

      const isLtMaxSize = file.size / 1024 / 1024 < UploadFileMaxSize;
      if (!isLtMaxSize) {
        dispatch({
          type: FETCH_ERROR,
          payload: `File must be smaller than ${UploadFileMaxSize}MB!`,
        });
        return Upload.LIST_IGNORE;
      }

      setValidFileList([file]);
      setValidFileList([file]);

      return isRightFormat && isLtMaxSize;
    },
  };

  const aboutUsImageUploadProps = {
    name: 'file',
    multiple: false,
    maxCount: 1,
    beforeUpload: (file) => {
      const isRightFormat = filesImageFormats.includes(file.type);

      if (!isRightFormat) {
        dispatch({
          type: FETCH_ERROR,
          payload: 'Accepted file formats: JPG and PNG only',
        });
        return Upload.LIST_IGNORE;
      }
      const isLt2M = file.size / 1024 / 1024 < UploadFileMaxSizeForImage;
      if (!isLt2M) {
        dispatch({
          type: FETCH_ERROR,
          payload: `File must smaller than ${UploadFileMaxSizeForImage}MB!`,
        });
        return Upload.LIST_IGNORE;
      }

      setValidAboutUsImageFileList([file]);
      return isRightFormat && isLtMaxSize;
    },
  };

  const removeImageFileHandler = (file) => {
    setValidImageFileList((prevFileList) => {
      return prevFileList.filter((item) => item?.uid !== file?.uid);
    });
  };

  const removePbssSponsorFileHandler = (file) => {
    setValidPbssSponsorFileList((prevFileList) => {
      return prevFileList.filter((item) => item?.uid !== file?.uid);
    });
  };

  const removeAboutUsImageFileHandler = (file) => {
    setValidAboutUsImageFileList((prevFileList) => {
      return prevFileList.filter((item) => item?.uid !== file?.uid);
    });
  };

  const removeFileHandler = (file) => {
    setValidFileList((prevFileList) => {
      return prevFileList.filter((item) => item?.uid !== file?.uid);
    });
  };

  useEffect(() => {
    if (EditData) {
      form.setFieldsValue({
        ...EditData,
      });
      setPbssIntroState(EditData?.pbss_intro || '<p></p>');
      setOurMissionState(EditData?.our_mission || '<p></p>');
      EditData?.highlights_ids?.length > 0
        ? setValidImageFileList((prev) =>
            EditData?.highlights_ids?.map((item) => {
              return {
                uid: item?.id,
                name: displayFileName(item),
                status: 'done',
                url: `${applicationConfig.UPLOAD_URL}/${item?.name}`,
              };
            }),
          )
        : setValidImageFileList((prev) => []);
    }
  }, [EditData]);

  useEffect(() => {
    if (EditData) {
      form.setFieldsValue({
        ...EditData,
      });
      EditData?.pbss_sponsors_ids?.length > 0
        ? setValidPbssSponsorFileList((prev) =>
            EditData?.pbss_sponsors_ids?.map((item) => {
              return {
                uid: item?.id,
                name: displayFileName(item),
                status: 'done',
                url: `${applicationConfig.UPLOAD_URL}/${item?.name}`,
              };
            }),
          )
        : setValidPbssSponsorFileList((prev) => []);
    }
  }, [EditData]);

  useEffect(() => {
    if (EditData) {
      form.setFieldsValue({
        ...EditData,
      });
      if (EditData?.terms_and_conditions_id) {
        setValidFileList([
          {
            uid: EditData.terms_and_conditions_id.id,
            name: displayFileName(EditData.terms_and_conditions_id),
            status: 'done',
            url: `${applicationConfig.UPLOAD_URL}/${EditData.terms_and_conditions_id.name}`,
          },
        ]);
      } else {
        setValidFileList([]);
      }

      const aboutUsImage = EditData?.about_us_image_id || null;

      if (aboutUsImage?.id && aboutUsImage?.name) {
        setValidAboutUsImageFileList([
          {
            uid: aboutUsImage.id,
            name: displayFileName(aboutUsImage),
            status: 'done',
            url: `${applicationConfig.UPLOAD_URL}/${aboutUsImage.name}`,
          },
        ]);
      } else {
        setValidAboutUsImageFileList([]);
      }
    }
  }, [EditData]);

  const onFinish = (values) => {
    const ImageIds = [];
    const PbssSponsorIds = [];
    const data = new FormData();
    data.append('special_announcement', values.special_announcement);
    data.append('pbss_intro', pbssIntroState);
    data.append('our_mission', ourMissionState);
    if (EditData) {
      validImageFileList.forEach((validFile) => {
        EditData?.highlights_ids?.some((file) => file?.id === validFile?.uid)
          ? ImageIds.push(validFile?.uid)
          : data.append('highlights', validFile?.originFileObj || validFile);
      });
      data.append('highlights_ids', `[${ImageIds}]`);
    } else {
      validImageFileList?.forEach((file) =>
        data.append(`highlights`, file?.originFileObj || file),
      );
    }

    if (EditData) {
      validPbssSponsorFileList.forEach((validFile) => {
        EditData?.pbss_sponsors_ids?.some((file) => file?.id === validFile?.uid)
          ? PbssSponsorIds.push(validFile?.uid)
          : data.append('pbss_sponsors', validFile?.originFileObj || validFile);
      });
      data.append('pbss_sponsors_ids', `[${PbssSponsorIds}]`);
    } else {
      validPbssSponsorFileList?.forEach((file) =>
        data.append('pbss_sponsors', file?.originFileObj || file),
      );
    }

    if (EditData) {
      const FileIds = [];
      validFileList.forEach((validFile) => {
        if (EditData?.terms_and_conditions_id?.id === validFile?.uid) {
          FileIds.push(validFile?.uid);
        } else {
          data.append(
            'terms_and_conditions',
            validFile?.originFileObj || validFile,
          );
        }
      });
      data.append('terms_and_conditions_id', `[${FileIds}]`);
    } else {
      validFileList?.forEach((file) =>
        data.append('terms_and_conditions', file?.originFileObj || file),
      );
    }

    const existingAboutUsImage = EditData?.about_us_image_id || null;

    if (EditData) {
      let aboutUsImageId = null;
      validAboutUsImageFileList.forEach((validFile) => {
        if (existingAboutUsImage?.id === validFile?.uid) {
          aboutUsImageId = validFile?.uid;
        } else {
          data.append('about_us_image', validFile?.originFileObj || validFile);
        }
      });
      if (aboutUsImageId != null) {
        data.append('about_us_image_id', aboutUsImageId);
      } else if (
        existingAboutUsImage?.id &&
        validAboutUsImageFileList.length === 0
      ) {
        data.append('about_us_image_id', '[]');
      }
    } else {
      validAboutUsImageFileList?.forEach((file) =>
        data.append('about_us_image', file?.originFileObj || file),
      );
    }
    updatePbssInternational(data, EditData.id);
  };

  const onFinishFailed = (errorInfo) => {
    console.error('Failed:', errorInfo);
  };
  const onReset = () => {
    form.resetFields();
    setValidImageFileList([]);
    setValidAboutUsImageFileList([]);
    setValidPbssSponsorFileList([]);
    setValidFileList([]);
    setPbssIntroState('<p></p>');
    setOurMissionState('<p></p>');
  };

  const dummyRequest = ({file, onSuccess}) => {
    setTimeout(() => {
      onSuccess('ok');
    }, 0);
  };

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  return (
    <div className='head-main-container pbss-international-admin-form'>
      <div className='main-form-container'>
        <Form
          form={form}
          name='basic'
          onFinish={onFinish}
          layout='vertical'
          className='two-column-form'
          onFinishFailed={onFinishFailed}
          autoComplete='off'
          initialValues={''}>
          {/* Title row: PBSS International | About Us */}
          <div className='input-container form-row'>
            <div className='form-column' style={{fontWeight: 600}}>
              PBSS International
            </div>
            <div className='form-column' style={{fontWeight: 600}}>
              About Us
            </div>
          </div>
          {/* Row 1: Special Announcement | Introduction */}
          <div className='input-container form-row'>
            <div className='form-column'>
              <Form.Item
                label='Special Announcement'
                name='special_announcement'
                rules={[
                  {
                    required: true,
                    message: 'Special Announcement should not be empty',
                  },
                ]}>
                <TextArea
                  className='special-announcement-textarea'
                  placeholder='Enter special announcement'
                  rows={8}
                  autoSize={{minRows: 8, maxRows: 16}}
                />
              </Form.Item>
            </div>
            <div className='form-column'>
              <Form.Item label='Introduction' name='pbss_intro'>
                <CommonEditor
                  value={pbssIntroState}
                  onChange={setPbssIntroState}
                  text={'pbss_intro'}
                  placeholderValue={'Introduction'}
                />
              </Form.Item>
            </div>
          </div>
          {/* Row 2: Event Highlights | Mission */}
          <div className='input-container form-row'>
            <div className='form-column'>
              <Form.Item
                name='highlights'
                label={'Event Highlights'}
                getValueFromEvent={normFile}>
                <Upload
                  prefixCls='upload-list-name-fix-class-admin'
                  className='common-input-user genral-form height-auto pd-y-20'
                  {...uploadPropsImage}
                  accept='.jpg, .jpeg, .png'
                  onRemove={removeImageFileHandler}
                  customRequest={dummyRequest}
                  fileList={validImageFileList}
                  showUploadList={true}>
                  <div>
                    <UploadOutlined className='upload-logo-admin' />
                    <div>
                      <span className='upload-text-logos-admin'>
                        Highlights
                      </span>
                    </div>
                    <div className='upload-type-admin'>
                      <span className='upload-desc-admin'>
                        Accepts only jpg,jpeg and png files.
                      </span>
                      <br />
                      <span className='upload-desc-admin'>
                        {`Maximum file size is ${UploadFileMaxSizeForImages}MB.`}
                      </span>
                    </div>
                  </div>
                </Upload>
              </Form.Item>
            </div>
            <div className='form-column'>
              <Form.Item label='Mission' name='our_mission'>
                <CommonEditor
                  value={ourMissionState}
                  onChange={setOurMissionState}
                  text={'our_mission'}
                  placeholderValue={'Mission'}
                />
              </Form.Item>
            </div>
          </div>
          {/* Row 3: Terms and Condition | Image Upload */}
          <div className='input-container form-row'>
            <div className='form-column'>
              <Form.Item
                name='pbss_sponsors'
                label={'PBSS Sponsors'}
                getValueFromEvent={normFile}>
                <Upload
                  prefixCls='upload-list-name-fix-class-admin'
                  className='common-input-user genral-form height-auto pd-y-20'
                  {...uploadPropsPbssSponsors}
                  accept='.jpg, .jpeg, .png'
                  onRemove={removePbssSponsorFileHandler}
                  customRequest={dummyRequest}
                  fileList={validPbssSponsorFileList}
                  showUploadList={true}>
                  <div>
                    <UploadOutlined className='upload-logo-admin' />
                    <div>
                      <span className='upload-text-logos-admin'>
                        PBSS Sponsors
                      </span>
                    </div>
                    <div className='upload-type-admin'>
                      <span className='upload-desc-admin'>
                        Accepts only jpg,jpeg and png files.
                      </span>
                      <br />
                      <span className='upload-desc-admin'>
                        {`Maximum file size is ${UploadFileMaxSizeForImages}MB.`}
                      </span>
                    </div>
                  </div>
                </Upload>
              </Form.Item>

              <Form.Item
                name='Upload File'
                label={'Terms and Condition'}
                getValueFromEvent={normFile}>
                <Upload
                  prefixCls='upload-list-name-fix-class-admin'
                  className='common-input-user genral-form height-auto pd-y-20'
                  {...fileUploadProps}
                  accept='.pdf'
                  onRemove={removeFileHandler}
                  customRequest={dummyRequest}
                  fileList={validFileList}
                  showUploadList={true}>
                  <div>
                    <UploadOutlined className='upload-logo-admin' />
                    <div>
                      <span className='upload-text-logos-admin'>
                        Upload File
                      </span>
                    </div>
                    <div className='upload-type-admin'>
                      <span className='upload-desc-admin'>
                        Accepts only pdf files.
                      </span>
                      <br />
                      <span className='upload-desc-admin'>
                        {`Maximum file size is ${UploadFileMaxSize}MB.`}
                      </span>
                    </div>
                  </div>
                </Upload>
              </Form.Item>
            </div>
            <div className='form-column'>
              <Form.Item
                name='about_us_image'
                label={'Image Upload'}
                getValueFromEvent={normFile}>
                <Upload
                  prefixCls='upload-list-name-fix-class-admin'
                  className='common-input-user genral-form height-auto pd-y-20'
                  {...aboutUsImageUploadProps}
                  accept='.jpg, .jpeg, .png'
                  onRemove={removeAboutUsImageFileHandler}
                  customRequest={dummyRequest}
                  fileList={validAboutUsImageFileList}
                  showUploadList={true}>
                  <div>
                    <UploadOutlined className='upload-logo-admin' />
                    <div>
                      <span className='upload-text-logos-admin'>
                        About Us Image
                      </span>
                    </div>
                    <div className='upload-type-admin'>
                      <span className='upload-desc-admin'>
                        Accepts only jpg,jpeg and png files.
                      </span>
                      <br />
                      <span className='upload-desc-admin'>
                        {`Maximum file size is ${UploadFileMaxSizeForImage}MB.`}
                      </span>
                    </div>
                  </div>
                </Upload>
              </Form.Item>
            </div>
          </div>

          <Form.Item>
            <div className='button-container'>
              <Button
                className='common-submit-login common-form-submit common-form-cancel'
                htmlType='button'
                id='adminStem-resetButton-reset'
                onClick={onReset}>
                {ApplicationString['dynamicSearch.button.reset']}
              </Button>
              <Button
                id='adminStem-submitButton-button'
                type='primary'
                htmlType='submit'
                className='common-submit-login common-form-submit'>
                {ApplicationString['dynamicSearch.button.update']}
              </Button>
            </div>
          </Form.Item>
        </Form>
      </div>{' '}
    </div>
  );
};

export default PbssInternationalComponent;
